<template>
    <div id="header" class="d-flex flex-row justify-content-around">
        <div id="novotelLogo"></div>
    </div>
</template>

<script>
export default {
  name: 'NovotelRatesHorizontalV1Header',
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    test () {
      return this.$route.query.test
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_novotel.scss";

#header {
    width: 100%;
    @include heightPercent(145);
    font-size: 1.3rem;
    font-family: "HouschkaAltPro-DemiBold";
    color: $purple;
    text-transform: uppercase;
    text-align: center;

    #novotelLogo {
        @include widthPercent(680);
        height: 100%;
        background: url(./assets/logoNovotel.jpg) no-repeat;
        background-size: contain;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v1/header.vue